export default __webpack_public_path__ + "static/media/photo 10.7730a4f9.jpg";